import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { createContext, useContext, useMemo } from 'react';
import { SpacingName } from '../../theme';
import * as styles from './HList.style';
const DEFAULT_INLINE = 4;
const DEFAULT_ITEM_WIDTH = '18rem';
const HListContext = /*#__PURE__*/createContext({
  inline: DEFAULT_INLINE,
  itemWidth: DEFAULT_ITEM_WIDTH,
  sideSpacing: SpacingName.ZERO
});
const HListItem = _ref => {
  let {
    children
  } = _ref;
  const {
    inline,
    itemWidth,
    sideSpacing
  } = useContext(HListContext);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $inline: inline,
    $itemWidth: itemWidth,
    $sideSpacing: sideSpacing,
    $_css: styles.item
  }, children);
};
export const HList = _ref2 => {
  let {
    scrollRef,
    sideSpacing,
    inline,
    itemWidth,
    onScroll,
    children,
    ...rest
  } = _ref2;
  const hListContext = useMemo(() => ({
    inline: inline,
    itemWidth: itemWidth,
    sideSpacing: sideSpacing
  }), [inline, itemWidth, sideSpacing]);
  return /*#__PURE__*/React.createElement(_StyledDiv2, _extends({
    $sideSpacing: sideSpacing
  }, rest, {
    $_css2: styles.base
  }), /*#__PURE__*/React.createElement(HListContext.Provider, {
    value: hListContext
  }, /*#__PURE__*/React.createElement(_StyledDiv3, {
    ref: scrollRef,
    "data-ref": "scroller",
    onScroll: onScroll,
    $_css3: styles.scroller
  }, /*#__PURE__*/React.createElement(_StyledDiv4, {
    $sideSpacing: sideSpacing,
    $_css4: styles.content
  }, children))));
};
HList.Item = HListItem;
HList.defaultProps = {
  sideSpacing: SpacingName.ZERO,
  inline: DEFAULT_INLINE,
  itemWidth: DEFAULT_ITEM_WIDTH
};
export default HList;
var _StyledDiv = _styled("div").withConfig({
  displayName: "HList___StyledDiv",
  componentId: "sc-15iuhhd-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "HList___StyledDiv2",
  componentId: "sc-15iuhhd-1"
})(["", ""], p => p.$_css2);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "HList___StyledDiv3",
  componentId: "sc-15iuhhd-2"
})(["", ""], p => p.$_css3);
var _StyledDiv4 = _styled("div").withConfig({
  displayName: "HList___StyledDiv4",
  componentId: "sc-15iuhhd-3"
})(["", ""], p => p.$_css4);
//# sourceMappingURL=HList.js.map